import { Injectable } from '@angular/core'
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Observable, of } from 'rxjs'
import { delay, mergeMap, retryWhen } from 'rxjs/operators'

export const maxRetries = 2
export const delayMs = 2000

@Injectable({ providedIn: 'root' })
export class RetryInterceptor implements HttpInterceptor {
  //retry 500 errors
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      retryWhen((error) => {
        return error.pipe(
          mergeMap((error, index) => {
            if (index < maxRetries && error.status == 500) {
              return of(error).pipe(delay(delayMs))
            }

            throw error
          }),
        )
      }),
    )
  }
}
